import { connect, useDispatch } from "react-redux";
import { RootState } from "../../store/root-reducer";
import { IconCloudUpload, IconLoader2 } from "@tabler/icons-react";
import { FaFilePdf } from "react-icons/fa6";
import { uploadDocuments } from "../../store/pending-contract/actions";
import { shortenFileName } from "../../helper";
import { isScopeLoading } from "../../store/scope-loading/helpers";
import { PendingContractScope } from "../../store/pending-contract/types";
import toast from "react-hot-toast";

function UploadInvoice({ documents, loading }) {
  const dispatch = useDispatch();
  return (
    <div className=" max-w-[500px] mx-auto w-full">
      <div className="rounded-md bg-gray-100 overflow-hidden p-9 py-4.5 relative ">
        <h2 className="text-2xl text-gray-800 pb-4 font-semibold text-center">
          Drop Invoice Here...
        </h2>
        <div className="bg-white w-full border-gray-400 border border-dashed border- flex-col rounded-[10px] flex justify-center items-center relative sm:p-5 p-4 h-[150px]">
          <input
            type="file"
            className="absolute inset-0 text-transparent opacity-0 cursor-pointer"
            accept="image/png, image/jpeg, image/jpg, application/pdf"
            multiple
            onChange={(e) => {
              const files = Array.from(e?.target?.files);
              const validFiles = files.filter((file) => {
                const fileExtension = file.name.split(".").pop().toLowerCase();
                return (
                  fileExtension === "png" ||
                  fileExtension === "jpg" ||
                  fileExtension === "jpeg" ||
                  fileExtension === "pdf"
                );
              });
              if (validFiles.length === 0) {
                toast.error("Please upload a valid file(PNG, JPG, JPEG, PDF)", {
                  position: "bottom-center",
                });
              } else {
                dispatch(uploadDocuments(validFiles));
              }
              e.target.value = "";
            }}
            disabled={loading}
          />
          <div className="mb-1">
            <IconCloudUpload stroke={1} className="text-gray-500" size={40} />
          </div>
          <span className="text-gray-500 text-sm text-center">
            Click or Drag Files to Upload
          </span>
        </div>
        {loading && (
          <div className="absolute flex justify-center items-center pointer-events-none cursor-not-allowed inset-0 bg-gray-100/50">
            <IconLoader2 className="size-8 text-gray-700 animate-spin" />
          </div>
        )}
      </div>
      {documents.map((item) => {
        const fileName = item.split("/")?.pop();
        const extension = fileName?.substring(fileName.lastIndexOf(".") + 1);
        const ISPDF = extension?.toLowerCase() === "pdf";
        return (
          <div key={item} className="my-2 flex items-center w-full">
            <div className="flex items-center  bg-gray-100 rounded-md p-2 w-full overflow-hidden">
              {ISPDF ? (
                <FaFilePdf
                  className="size-10 object-cover mr-2 text-gray-500 cursor-pointer"
                  onClick={() => {
                    window.open(item, "_blank");
                  }}
                />
              ) : (
                <img
                  src={item}
                  alt=""
                  className="size-10 object-cover rounded mr-2 cursor-pointer"
                  onClick={() => {
                    window.open(item, "_blank");
                  }}
                />
              )}
              <span className="overflow-hidden w-full text-ellipsis text-gray-500">
                {shortenFileName(fileName, 40)}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  documents: state.pendingContract.documents || [],
  loading: isScopeLoading(state.scopeLoading, PendingContractScope),
});

export default connect(mapStateToProps)(UploadInvoice);
